import React from 'react';
import Item from './Item';

export const CheckRadioList = ({
  closeDDM,
  closeOnBlurDDM,
  items,
  selectedId,
  classNames,
  onSelect,
  focus,
  setFocusPosition,
  parentPositionIndex,
  parentItemsSize,
  hasContainerFocus,
}) => {
  return (
    <ul role="menu" className={`check-radio-list ${classNames}`}>
      {items.map((item, index) => {
        const focusedItem =
          parentPositionIndex === focus.focusIndex && focus.focusInnerIndex === index && hasContainerFocus;

        return (
          <Item
            key={item.id}
            item={item}
            closeDDM={closeDDM}
            closeOnBlurDDM={closeOnBlurDDM}
            itemsSize={items.length}
            checked={item.id === selectedId}
            onSelect={onSelect}
            focus={focus}
            focusedItem={focusedItem}
            positionIndex={index}
            parentPositionIndex={parentPositionIndex}
            setFocusPosition={setFocusPosition}
            parentItemsSize={parentItemsSize}
          />
        );
      })}
    </ul>
  );
}

export default CheckRadioList;
